import {ENDPOINTS, sendAsyncRequest} from "../utils";
import { CalendarParams, AddJobScheduleProps, ApiResponse } from "../types/api.types";

const getMyCalendar = async (params?: CalendarParams): Promise<ApiResponse> => {
    const myCalendarResponse = await sendAsyncRequest<ApiResponse>('get', ENDPOINTS.MyCalendar, true, params, undefined);
    return myCalendarResponse.data;
};
const getMyWeekCalendar = async (params: CalendarParams, url: string): Promise<ApiResponse> => {
    const weekCalendarResponse = await sendAsyncRequest<ApiResponse>('get', url, true, params, undefined);
    return weekCalendarResponse.data;
};

const deleteIntervention = async (id: string): Promise<ApiResponse> => {
    const response = await sendAsyncRequest<ApiResponse>('delete', ENDPOINTS.JobScheduleMin + '/' + id, true, undefined, undefined);
    return response.data;
};

const addJobSchedule = async (data: AddJobScheduleProps, url: string): Promise<ApiResponse> => {
    const newJob = await sendAsyncRequest<ApiResponse>('post', url, true, undefined, data);
    return newJob.data;
}

// Re-export for backward compatibility
export type { AddJobScheduleProps as addJobScheduleProps };
export const calendarService = {
    getMyCalendar,
    addJobSchedule,
    getMyWeekCalendar,
    deleteIntervention
}
